(() => {
  const buttonSelector = '[data-barcode-search]';
  let stream;
  let animationFrame;

  const stopCamera = () => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      stream = null;
    }
  };

  const closeScanner = (overlay) => {
    stopCamera();
    if (overlay instanceof HTMLDialogElement && overlay.open) {
      overlay.close();
    }
    overlay?.remove();
    document.documentElement.classList.remove('ce-barcode-search-open');
  };

  const findSearchInput = (button) => {
    const form = button.closest('form');
    const input = form?.querySelector('input[name="q"]');

    return { form, input };
  };

  const submitSearch = (button, value) => {
    const code = value?.trim();
    const { form, input } = findSearchInput(button);

    if (!code || !form || !input) return;

    input.value = code;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(() => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }

      form.submit();
    }, 120);
  };

  const manualBarcodeSearch = (button) => {
    const code = window.prompt('Enter barcode or SKU');
    submitSearch(button, code);
  };

  const createScannerOverlay = (button) => {
    const overlay = document.createElement('div');
    overlay.className = 'ce-barcode-search-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Scan barcode');
    overlay.innerHTML = `
      <div class="ce-barcode-search-dialog">
        <div class="ce-barcode-search-dialog__top">
          <div>
            <p class="ce-barcode-search-dialog__eyebrow">Barcode search</p>
            <h2>Scan product barcode</h2>
          </div>
          <button type="button" class="ce-barcode-search-dialog__close" aria-label="Close scanner">Close</button>
        </div>
        <div class="ce-barcode-search-video-frame">
          <video class="ce-barcode-search-video" autoplay muted playsinline></video>
          <span class="ce-barcode-search-target" aria-hidden="true"></span>
        </div>
        <p class="ce-barcode-search-dialog__status">Place the barcode inside the frame. The search will open automatically.</p>
      </div>
    `;

    const openDialog = button.closest('dialog[open]') || document.querySelector('dialog[open]');
    const mount = openDialog || document.body;

    mount.appendChild(overlay);
    document.documentElement.classList.add('ce-barcode-search-open');
    overlay.setAttribute('open', '');

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target.closest('.ce-barcode-search-dialog__close')) {
        closeScanner(overlay);
      }
    });

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape') closeScanner(overlay);
      },
      { once: true }
    );

    return overlay;
  };

  const scanBarcode = async (button) => {
    if (!('BarcodeDetector' in window) || !navigator.mediaDevices?.getUserMedia) {
      manualBarcodeSearch(button);
      return;
    }

    const overlay = createScannerOverlay(button);
    const video = overlay.querySelector('.ce-barcode-search-video');
    const status = overlay.querySelector('.ce-barcode-search-dialog__status');

    try {
      const detector = new BarcodeDetector({
        formats: ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'code_39', 'code_93', 'itf', 'codabar', 'qr_code'],
      });

      stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
        audio: false,
      });

      video.srcObject = stream;
      await video.play();

      const detect = async () => {
        if (!stream) return;

        try {
          const barcodes = await detector.detect(video);
          const code = barcodes?.[0]?.rawValue;

          if (code) {
            status.textContent = `Searching SKU ${code}`;
            closeScanner(overlay);
            submitSearch(button, code);
            return;
          }
        } catch (error) {
          status.textContent = 'Unable to read the barcode. Try holding the product steady.';
        }

        animationFrame = requestAnimationFrame(detect);
      };

      detect();
    } catch (error) {
      closeScanner(overlay);
      manualBarcodeSearch(button);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(buttonSelector);

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    scanBarcode(button);
  }, true);
})();
